var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barrage"},[_c('div',{ref:"trajectory",staticClass:"barrage__trajectory",style:({
      height: _vm.proportion + '%',
      opacity: _vm.opacity / 100
    })}),_c('div',{ref:"topOrBottom",staticClass:"barrage__top-or-bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }